// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5364":"e0336300b5bccd2c","6681":"e6fa5cfc2399457c"}[chunkId] + ".js";
};